import { MENU_ITEM } from '../constants/constants';

export const getMenuItemTheme = ({ resource }) => {
    const componentStyle = resource?.component_style || '';

    return MENU_ITEM?.[componentStyle] || 'mod8';
};
